export default __webpack_public_path__ + "static/media/logo_macread.a5baab36.png";